/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as AvatarCustomIcon } from './avatar-custom-icon.story';
export { default as AvatarDefault } from './avatar-default.story';
export { default as AvatarDisabled } from './avatar-disabled.story';
export { default as AvatarSizes } from './avatar-sizes.story';
export { default as AvatarShapes } from './avatar-shapes.story';
export { default as AvatarTypes } from './avatar-types.story';
export { default as AvatarStatuses } from './avatar-statuses.story';

import { removeLicenseHeader } from '../../_common/export-stories-utils';
import AvatarCustomIconSourceRaw from './avatar-custom-icon.story?raw';
import AvatarDefaultSourceRaw from './avatar-default.story?raw';
import AvatarDisabledSourceRaw from './avatar-disabled.story?raw';
import AvatarShapesSourceRaw from './avatar-shapes.story?raw';
import AvatarSizesSourceRaw from './avatar-sizes.story?raw';
import AvatarStatusesSourceRaw from './avatar-statuses.story?raw';
import AvatarTypesSourceRaw from './avatar-types.story?raw';

export const AvatarCustomIconSource = removeLicenseHeader(
  AvatarCustomIconSourceRaw,
);
export const AvatarDefaultSource = removeLicenseHeader(AvatarDefaultSourceRaw);
export const AvatarDisabledSource = removeLicenseHeader(
  AvatarDisabledSourceRaw,
);
export const AvatarSizesSource = removeLicenseHeader(AvatarSizesSourceRaw);
export const AvatarShapesSource = removeLicenseHeader(AvatarShapesSourceRaw);
export const AvatarTypesSource = removeLicenseHeader(AvatarTypesSourceRaw);
export const AvatarStatusesSource = removeLicenseHeader(
  AvatarStatusesSourceRaw,
);
